import { render, staticRenderFns } from "./Detect.vue?vue&type=template&id=7dca6ea2&scoped=true&"
import script from "./Detect.vue?vue&type=script&lang=js&"
export * from "./Detect.vue?vue&type=script&lang=js&"
import style0 from "./Detect.vue?vue&type=style&index=0&id=7dca6ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dca6ea2",
  null
  
)

export default component.exports